import { Tag, merge } from '../../Context/dist/effect-Context.esm.js';
import { fiberRefLocallyWith } from '../../internal/core.esm.js';
import { currentServices } from '../../internal/defaultServices.esm.js';

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */
const TestLiveTypeId = /*#__PURE__*/Symbol.for("effect/TestLive");

/**
 * @since 2.0.0
 */

/**
 * The `Live` trait provides access to the "live" default Effect services from
 * within tests for workflows such as printing test results to the console or
 * timing out tests where it is necessary to access the real implementations of
 * these services.
 *
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */
const TestLive = /*#__PURE__*/Tag( /*#__PURE__*/Symbol.for("effect/TestLive"));

/** @internal */
class LiveImpl {
  [TestLiveTypeId] = TestLiveTypeId;
  constructor(services) {
    this.services = services;
  }
  provide(effect) {
    return fiberRefLocallyWith(currentServices, merge(this.services))(effect);
  }
}

/**
 * @since 2.0.0
 */
const make = services => new LiveImpl(services);

export { TestLive, TestLiveTypeId, make };
